<template>
    <v-btn v-bind="$attrs"
           v-on="$listeners"
           outlined
           color="primary">
        <slot></slot>
    </v-btn>

</template>
<script>
    export default {
    }
</script>
